<div class="out"  kzLib (click)="savePDFAs()">
  <img src="assets/images/save.svg">
  Save as copy
</div>
